{
  "serviceForms": {
    "joinCorporateForm": {
      "fields": {
        "authorisedSignatory": {
          "label": "I have the right to make this agreement on behalf of my company",
          "description": "If you travel for work and would like your company to join, please share this page with an authorised representative.",
          "required": "Confirmation is required"
        },
        "country": {
          "availability": "Finnair for Business is available in these countries."
        }
      },
      "summary": {
        "confirmationTitle": "Confirm your application",
        "confirmationText": "<p>Please read <a href=\"{link}\" target=\"_blank\" rel=\"noopener noreferrer\">The Finnair for Business membership terms and conditions</a> before you submit your application. To see how we use personal data and what rights you have, read our <a data-contentid=\"442094\" href=\"/en/info/finnair-privacy-notice\" target=\"_blank\" rel=\"noopener noreferrer\">privacy policy</a>.</p>",
        "termsConfirmation": {
          "label": "I have read the terms and conditions, and my company agrees to follow them. I confirm that the information I have given is correct.",
          "required": "Required field"
        }
      },
      "travelAgency": {
        "title": "Travel management company (3/4)",
        "info": "<p>If your company books flights through a travel management company, add its details here. Your team can then get Finnair for Business discounts and benefits when booking through it.</p><p>If you don’t use one, or don’t have the details yet, select <b>Next</b>. You can send them to us later.</p>",
        "checkbox": {
          "label": "Add travel management company details"
        }
      }
    }
  }
}
